import LocationActionMenu, { LocationActionItem } from "./LocationActionMenu";

export interface LocationMobileActionItem extends LocationActionItem {}

interface LocationMobileActionMenuProps {
    items: LocationMobileActionItem[];
    buttonClassName?: string;
    ariaLabel?: string;
}

export default function LocationMobileActionMenu({
    items,
    buttonClassName = "p-button-text location-mobile-card-menu-btn",
    ariaLabel = "Opciones"
}: Readonly<LocationMobileActionMenuProps>) {
    return (
        <LocationActionMenu
            items={items}
            buttonClassName={buttonClassName}
            ariaLabel={ariaLabel}
            panelClassName="location-mobile-action-menu-panel"
            contentClassName="w-64"
        />
    );
}

